import Alpine from "alpinejs";
import { ScrollSpy, ScrollSpyInit } from "../components/scroll-spy/scroll-spy";
import { SlideToggleBinders } from "../modules/_SlideToggleHelpers";
import intersect from '@alpinejs/intersect'
// import { FeaturedDevelopment, FeaturedDevelopmentCopySlider, FeaturedDevelopmentList, FeaturedDevelopmentsInit } from "../components/featured-development/featured-development-list";
import { ColorFlipCard, ColorFlipCardInit, ColorFlipCardList } from "../components/color-flip-card/color-flip-card-list";
import { FeaturedDevelopment, FeaturedDevelopmentCopySlider, FeaturedDevelopmentList, FeaturedDevelopmentsInit } from "../components/featured-development/featured-development-list";
import { InteractivePhotoInit } from "../components/interactive-photo/interactive-photo";
import UnescapeHtml from "./../modules/_UnescapeHtml";
import { Modal } from "../modules/_Modal";

Alpine.plugin(intersect);
UnescapeHtml();

// import { FeaturedDevelopment, FeaturedDevelopmentList } from "../components/featured-development/featured-development-list";
// import {
//   AccordionToggleNext,
//   SlideToggleNext,
//   SlideToggleBinders,
// } from "../modules/SlideToggle";
// import { TextContentProcessor } from "../modules/TextContentProcessor";

// Alpine.store("menuOpen", false);

// Alpine.bind("textContent", TextContentProcessor);
// Alpine.bind(SlideToggleBinders.accordionTrigger, AccordionToggleNext);
// Alpine.bind(SlideToggleBinders.slideTrigger, SlideToggleNext);

window.Alpine = Alpine;

SlideToggleBinders.map(([binderName, binderObject]) => {
  Alpine.bind(binderName, binderObject);
});

FeaturedDevelopmentsInit();
ColorFlipCardInit();
ScrollSpyInit();
InteractivePhotoInit();

Alpine.store('modal', Modal);


Alpine.start();

document.addEventListener('alpine:init', () => {
});
